import React from "react";
import { MetricUId } from '../../Metrics/constants';
import { getMetricDataFromArray } from '../../Metrics/utils';
import InAWordResponsesContainer from "./InAWordResponsesContainer";
import ViewMoreDataContainer from "./ViewMoreDataContainer";

const Body = ({metrics}) => {
  const preMeetingResponseData = getMetricDataFromArray(metrics, MetricUId.IN_A_WORD_PRE_MEETING_RESPONSES).data.value;
  const postMeetingResponseData = getMetricDataFromArray(metrics, MetricUId.IN_A_WORD_POST_MEETING_RESPONSES).data.value;
  return (
    <div className="p-4">
      <InAWordResponsesContainer preMeetingResponsesData={preMeetingResponseData} postMeetingResponsesData={postMeetingResponseData} />
      {(preMeetingResponseData?.response_values?.length > 0 || postMeetingResponseData?.response_values?.length > 0) && (
        <ViewMoreDataContainer 
          preMeetingResponsesData={preMeetingResponseData} 
          postMeetingResponsesData={postMeetingResponseData}
        />
      )}
    </div>
  );
}

export default Body;   